/**
 * Secondary Question Component
 *
 * Asks if user wants to add secondary insurance.
 * LoadingBar and navigation buttons are rendered by the parent layout.
 */

"use client";

import { useTranslations } from "@frontend/lib/next-intl-typed";

export function SecondaryQuestion() {
  const t = useTranslations("InsuranceConnector");

  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-2xl md:text-[32px] leading-[120%] tracking-[-0.02em] font-semibold">
        {t("AddSecondaryInsuranceQuestion")}
      </h2>
    </div>
  );
}
